import { IScheduleRelationship } from '../../interfaces/ischedule-relationship';
import { Schedule } from '../schedule';
import { ScheduleRelationshipType } from '../schedule-relationship-type';

export class ScheduleRelationshipBase {
  ScheduleRelationshipId: number;
  Scheduleid: number;
  PredecessorScheduleActivityId: number;
  SuccessorScheduleActivityId: number;
  Lag: number;
  P6RelationshipObjectId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  ScheduleRelationshipTypeId: number | null;
  SentToP6: Date | null;
  ReceivedByP6: Date | null;

  ScheduleRelationshipType?: ScheduleRelationshipType;
  Schedule?: Schedule;

  constructor(item?: IScheduleRelationship) {
    if (item) {

      this.ScheduleRelationshipId = item.ScheduleRelationshipId;
      this.Scheduleid = item.Scheduleid;
      this.PredecessorScheduleActivityId = item.PredecessorScheduleActivityId;
      this.SuccessorScheduleActivityId = item.SuccessorScheduleActivityId;
      this.Lag = item.Lag;
      this.P6RelationshipObjectId = item.P6RelationshipObjectId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.ScheduleRelationshipTypeId = item.ScheduleRelationshipTypeId;
      this.SentToP6 = item.SentToP6 ? new Date(item.SentToP6) : null;
      this.ReceivedByP6 = item.ReceivedByP6 ? new Date(item.ReceivedByP6) : null;

      this.ScheduleRelationshipType = new ScheduleRelationshipType(item.ScheduleRelationshipType);
      this.Schedule = new Schedule(item.Schedule);
    }
  }
}